import type {
  Activity as CoreActivity,
  ActivityListResponse as CoreActivityListResponse,
} from "@visioni/a3s-services-core";
import { apiRequest } from "./request";

// Re-export strongly-typed activity models from the shared core package
export type ActivityItem = CoreActivity;
export type ActivityListResponse = CoreActivityListResponse;

export type ActivityListParams = {
  siteId?: string;
  cameraKey?: string;
  limit?: number;
  offset?: number;
};

export const activityApi = {
  async list(tenantId: string, params: ActivityListParams = {}): Promise<ActivityListResponse> {
    const queryParts: string[] = [];

    if (params.siteId) {
      queryParts.push(`siteId=${encodeURIComponent(params.siteId)}`);
    }

    if (params.cameraKey) {
      queryParts.push(`cameraKey=${encodeURIComponent(params.cameraKey)}`);
    }

    if (typeof params.limit === "number") {
      queryParts.push(`limit=${params.limit}`);
    }

    if (typeof params.offset === "number") {
      queryParts.push(`offset=${params.offset}`);
    }

    const queryString = queryParts.length > 0 ? `?${queryParts.join("&")}` : "";

    return apiRequest<ActivityListResponse>({
      method: "GET",
      path: `/api/v1/tenants/${tenantId}/activity${queryString}`,
      logMessage: "Fetching activity from:",
    });
  },
};
